import React from 'react';
import { Button, Flex, Grid, Label, Text } from '@pega/cosmos-react-core';
import useLocalTranslation from '../../../../hooks/useLocalTranslation';
import { useSelector } from 'react-redux';
import { appState, SDKComponentProps } from '../../../../interfaces/common';

const SDKInstallation: React.FC<SDKComponentProps> = (props: SDKComponentProps) => {
  const { widgetId, iosSdkLink, androidSdkLink } = useSelector((state: appState) => state.chatInfo);
  const translate = useLocalTranslation();
  const { platform } = props;

  return (
    <>
      <Text variant="h2" as="h2">
        {`${translate(platform ?? '')}`}
      </Text>
      <Flex container={{ direction: 'column', itemGap: 2 }} item={{ grow: 1 }}>
        <Grid
          container={{
            cols: 'repeat(2, 33% 67%)',
            gap: 1,
            alignItems: 'center',
          }}
        >
          <Label>{translate('api_id')}</Label>
          <Flex
            container={{
              direction: 'row',
              itemGap: 1,
              alignItems: 'center',
            }}
          >
            <Text variant="secondary">{widgetId.replace('chat_', '')}</Text>
          </Flex>
        </Grid>
        <Grid
          container={{
            cols: 'repeat(2, 33% 67%)',
            gap: 1,
            alignItems: 'center',
          }}
        >
          <Label>{translate('api_url')}</Label>
          <Flex
            container={{
              direction: 'row',
              itemGap: 1,
              alignItems: 'center',
            }}
          >
            <Text variant="secondary">{process.env.REACT_APP_CHAT_WIDGET_URL}</Text>
          </Flex>
        </Grid>
      </Flex>
      <Flex>
        <Grid
          container={{
            cols: 'repeat(3, 31% 31% 38%)',
            gap: 1,
            alignItems: 'center',
          }}
        >
          <Button
            onClick={() => {
              if (iosSdkLink) window.open(iosSdkLink, '_blank');
            }}
          >{`Download ${translate('sdk_ios')}`}</Button>
          <Button
            onClick={() => {
              if (androidSdkLink) window.open(androidSdkLink, '_blank');
            }}
          >{`Download ${translate('sdk_android')}`}</Button>
        </Grid>
      </Flex>
    </>
  );
};

export default SDKInstallation;
